import React from 'react'
import clsx from 'clsx'
import styles from './UIGamePlayerInfoSectionContent.module.scss'
import {CardEnum} from '@colonist/game-states'
import {UIGameCard} from '../../../../../common/UIGameCard'
import {UIGamePlayerInfoSectionImageWithCount} from '../../UIGamePlayerInfoSectionImageWithCount/UIGamePlayerInfoSectionImageWithCount'
import IconLargestArmy from '@static/images/icon_largest_army.svg'
import IconLargestArmyHighlight from '@static/images/icon_largest_army_highlight.svg'
import IconDefenderOfColonist from '@static/images/icon_swords.svg'
import IconDefenderOfColonistHighlight from '@static/images/icon_swords_highlight.svg'
import IconLongestRoad from '@static/images/icon_longest_road.svg'
import IconLongestRoadHighlight from '@static/images/icon_longest_road_highlight.svg'
import {TooltipResourceCards} from './TooltipResourceCards'
import {T, Tooltip} from '@colonist/ui'
import {useUIGameTranslationContext} from '../../../../../contexts/UIGameTranslationContext'

export interface UIGamePlayerInfoSectionContentHandProps {
    resourceCardCount: number
    resourceCardDiscardLimit: number
    developmentCardCount?: number | undefined
    progressCardCount?: number | undefined
    largestArmyCount?: number | undefined
    highlightLargestArmy?: boolean | undefined
    defenderOfColonistCount?: number | undefined
    highlightDefenderOfColonist?: boolean | undefined
    longestRoadCount?: number | undefined
    highlightLongestRoad?: boolean | undefined
}

export const UIGamePlayerInfoSectionContentHand = ({
    resourceCardCount,
    resourceCardDiscardLimit,
    developmentCardCount,
    progressCardCount,
    largestArmyCount,
    highlightLargestArmy,
    defenderOfColonistCount,
    highlightDefenderOfColonist,
    longestRoadCount,
    highlightLongestRoad,
}: UIGamePlayerInfoSectionContentHandProps) => {
    const isResourceCardCountOverLimit = resourceCardCount > resourceCardDiscardLimit
    const resourceCardEnum = isResourceCardCountOverLimit ? CardEnum.ResourceOverLimit : CardEnum.AnyResource
    const largestArmyIcon = highlightLargestArmy ? IconLargestArmyHighlight : IconLargestArmy
    const defenderOfColonistIcon = highlightDefenderOfColonist ? IconDefenderOfColonistHighlight : IconDefenderOfColonist
    const longestRoadIcon = highlightLongestRoad ? IconLongestRoadHighlight : IconLongestRoad
    const {translationKeyContext} = useUIGameTranslationContext()

    return (
        <div className={clsx(styles.container, styles.containerHand)}>
            <div data-resource-card>
                <TooltipResourceCards
                    resourceCardCount={resourceCardCount}
                    resourceCardDiscardLimit={resourceCardDiscardLimit}>
                    <UIGameCard
                        cardEnum={resourceCardEnum}
                        size='xs'
                        count={resourceCardCount}/>
                </TooltipResourceCards>
            </div>
            {developmentCardCount !== undefined && <div data-development-card>
                <Tooltip
                    content={<T id='strings:game.playerInformation.developmentCard.body'/>}
                    title={<T id='strings:game.playerInformation.developmentCard.title'/>}>
                    <UIGameCard
                        cardEnum={CardEnum.DevelopmentBack}
                        size='xs'
                        count={developmentCardCount} />
                </Tooltip>
            </div>}
            {progressCardCount !== undefined && <div data-development-card>
                <Tooltip
                    content={<T id='strings:game.playerInformation.progressCard'/>}>
                    <UIGameCard
                        cardEnum={CardEnum.ProgressCardBack}
                        size='xs'
                        count={progressCardCount} />
                </Tooltip>
            </div>}
            {largestArmyCount !== undefined && <Tooltip
                content={<T id='strings:game.playerInformation.largestArmy.body'/>}
                title={<T id='strings:game.playerInformation.largestArmy.title'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={largestArmyIcon}
                    count={largestArmyCount} />
            </Tooltip>}
            {defenderOfColonistCount !== undefined && <Tooltip
                content={<T id='strings:game.playerInformation.knightStrength.body'/>}
                title={<T id='strings:game.playerInformation.knightStrength.title'/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={defenderOfColonistIcon}
                    count={defenderOfColonistCount} />
            </Tooltip>}
            {longestRoadCount !== undefined && <Tooltip
                content={<T id={{
                    key: 'strings:game.playerInformation.longestRoad.body',
                    options: {context: translationKeyContext},
                }}/>}
                title={<T id={{
                    key: 'strings:game.playerInformation.longestRoad.title',
                    options: {context: translationKeyContext},
                }}/>}>
                <UIGamePlayerInfoSectionImageWithCount
                    piece={longestRoadIcon}
                    count={longestRoadCount} />
            </Tooltip>}
        </div>
    )
}
